import { httpClient } from '../httpClient';

export const adminApi = {
  getDataFlowMap:     () => httpClient.get('/admin/data-flow-map'),
  getDataFlowPulse:   () => httpClient.get('/admin/data-flow-pulse'),
  getSchedulerStatus: () => httpClient.get('/admin/scheduler-status'),
  listCeremonies:     () => httpClient.get('/admin/ceremonies'),
  getCeremony:        (key) => httpClient.get(`/admin/ceremonies/${encodeURIComponent(key)}`),
  getDataFlowCatalog: () => httpClient.get('/admin/data-flow-catalog'),
};
